const http_apiport = 3047;
const https_apiport = 3050;

const domain = window.location.hostname;
const port = window.location.port;
const debug =
  domain.toLowerCase().includes("mongo1") ||
  domain.toLowerCase().includes("172.16.7.217"); // debug if contains mongo url
const url = debug ? `http://${domain}:${port}` : `https://esign.myshs.com`;
const apiUrl = debug
  ? `http://${domain}:${http_apiport}/api`
  : `https://esign.myshs.com:${https_apiport}/api`;
// the http port is 3047 while https port is 3050

export const getUrl = () => {
  return url;
};

export const getApiUrl = () => {
  return apiUrl;
};
